export default __webpack_public_path__ + "static/mx-14323369d3709b556c4e48da6e8930bf.svg";